import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { MenuContext } from '../../../contexts/menu';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MUILink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import { drawerWidth } from '../../../constants';
import { SxStyle } from '../../../types';
import { BreadCrumpItem } from '../../../hooks/useBreadcrumbs';

const styles: SxStyle = {
  appBar: (theme) => ({
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
    },
    backgroundColor: theme.palette.background.default,
    boxShadow: 'none',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: 'rgb(0, 0, 0, 12%)',
  }),
  link: {
    textDecoration: 'none',
    color: '#0673CA',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  selectedButton: (theme) => ({
    backgroundColor: theme.palette.primary.dark,
  }),
  menuButton: (theme) => ({
    marginRight: 2,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  }),
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > *': {
      marginRight: '20px',
    },
    marginLeft: '20px',
  },
};

export type BreadCrumpsList = (BreadCrumpItem | string)[];

export interface SceneTopBarProps {
  title: string;
  breadCrumps?: BreadCrumpsList;
}

function SceneTopBar({ title, breadCrumps }: SceneTopBarProps) {
  const { handleDrawerToggle } = useContext(MenuContext);

  return (
    <AppBar position="fixed" sx={styles.appBar} color="transparent">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={styles.menuButton}
          size="large"
        >
          <MenuIcon />
        </IconButton>

        <Breadcrumbs aria-label="breadcrumb">
          {breadCrumps &&
            breadCrumps.map((breadCrump, index) => {
              if (typeof breadCrump === 'string') {
                return (
                  <Typography color="text.primary" key={index}>
                    {breadCrump}
                  </Typography>
                );
              }
              if (breadCrump.to === '') {
                return (
                  <Typography color="text.primary" key={index}>
                    {breadCrump.text}
                  </Typography>
                );
              }
              return (
                <MUILink key={index} sx={styles.link} component={Link} to={breadCrump.to}>
                  {breadCrump.text}
                </MUILink>
              );
            })}
          <Typography color={breadCrumps ? 'text.default' : 'text.primary'}>{title}</Typography>
        </Breadcrumbs>
      </Toolbar>
    </AppBar>
  );
}

export default SceneTopBar;
